export const READONLY_PERMISSION = 'CNST_READONLY_REMAMOBILE';
